import LiveApi from './LocatorApi';

// Leaving this function in place for potential future needs.
const getAPI = () => {
  return LiveApi;
};

export default getAPI();
